export const APIEndPoints = Object.freeze({
    REVIEW_INFO: {
        UPDATE: 'ipj/user/profile',
        RESET: 'ipj/user/reset-password'
    },
    DASHBOARD : {
        GET_PROGRAM: 'ipj/user/activation',
        GET_ACTIVE_PROGRAM: 'ipj/utility/assignprogram'
    },
    HabitDrills : {
        GET_habit: 'ipj/habit-drill/list',
        GET_HABIT_DRILL_INFO: 'ipj/habit-drill/info/',
        POST_HABIT_DRILL_INFO: 'ipj/habit-drill/response/'
    },
    NotesAndBookmarks: {
        GET_NOTES: 'ipj/notes-and-bookmarks/'
    },
    LeaderBoard: {
        GetUserRankingList: 'ipj/programActivaton/leaderboardRanking'
    }

})